module.exports = __webpack_public_path__ + "static/media/arvidsjaurvapen.1ed87b6e.png";